module.exports = __webpack_public_path__ + "static/media/image6.3a2ca877.jpg";